import { FolderFilledIcon, RightChevronIcon } from '@_shared/icons';
import { Typography } from '@_shared/ui/Typography';

import * as S from './TextSummary.style';

const TITLE_MAX_LINES = 3;

interface ITextProps {
	children: React.ReactNode | string;
}

interface ILinkProps extends ITextProps {
	url: string;
}

export function Container({ children }: ITextProps) {
	return <S.Container>{children}</S.Container>;
}

export function Folder({ children }: ITextProps) {
	return (
		<S.TextRow>
			<FolderFilledIcon />
			<Typography type="body-medium" color="font-secondary">
				{children}
			</Typography>
		</S.TextRow>
	);
}

export function Title({ children }: ITextProps) {
	return (
		<Typography type="title-medium" color="font-primary" noOfLine={TITLE_MAX_LINES}>
			{children}
		</Typography>
	);
}

export function Link({ children, url }: ILinkProps) {
	return (
		<S.SummaryLink
			onClick={() => {
				window.location.href = url;
			}}
		>
			<Typography type="body-medium" color="font-tertiary">
				{children}
			</Typography>
			<Typography type="body-medium" color="font-tertiary">
				바로가기
			</Typography>
			<RightChevronIcon />
		</S.SummaryLink>
	);
}
